jQuery(document).ready(function ($) {
  welcome_message_in_console();
  $("#heroVideo").show();
  scrollDownButton();
  scrollToSection();
  // parallax();
  //resize();
  videoPlayer();
  employeeBio();
  showMoreContent();
  showMoreTable();
  animateNumbers();
  // workflow_readmore();
  //hideLogoOnMobile();
  ninjaFormBreadcrumbs();
  dropdown_location();
  multilangualForm();
  jotFormToggler();
  // portfolioFilters();
  // Start midnight

  $(".midnight").midnight();

  matchHeight();

  // In case image loads a bit too slow
  setTimeout(() => {
    matchHeight();
  }, 1000)

  // start animate on scroll
  AOS.init({
    once: true
  });
});



// function portfolioFilters() {

//   //clone default sections, will use it when clearing filters
//   default_sections = $('#fullpage').clone(); 

//   // hover effect on anchor links
//   $(".portfolio-filters button").mouseover(function (e) {
//     activeCategory = $(this).attr('data-project-category-name');
//     $('*[data-projects-categories="' + activeCategory + '"]').addClass('filter-active');
//     $('.portfolio-anchors').addClass('portfolio-anchors-filtered');
//   });
//   $(".portfolio-filters button").mouseleave(function (e) {
//     $('.portfolio-anchors').removeClass('portfolio-anchors-filtered');
//     $('*[data-projects-categories="' + activeCategory + '"]').removeClass('filter-active');
//   });



//   $(".portfolio-filters button").click(function (e) {
//     e.preventDefault();
//     activeCategory = $(this).attr('data-project-category-name');
//     console.log(activeCategory);
    
//     fullpage_api.destroy('all');
//     $('.flexible-content:not([data-projects-categories="' + activeCategory + '"])').removeClass('fp-section');
//     $('.flexible-content:not([data-projects-categories="' + activeCategory + '"])').remove();
//     initfullpage();
//   });


//   $(".clear-filter").click(function (e) {
//     e.preventDefault();
//     fullpage_api.destroy('all');
//     location.hash = '';
//     $('.flexible-content').addClass('fp-section');
//     $('.flexible-content').show();
//     $('#fullpage').replaceWith(default_sections);
//     initfullpage();
//     portfolioFilters();
//   });

// }
// function initfullpage() {
//   var $myFullpage = jQuery('#fullpage');
//   $myFullpage.fullpage({
//     licenseKey: '85E9D3CE-BA5F4526-8C42E536-D29EEBDF',
//     scrollHorizontally: false,
//     navigation: true,
//     navigationPosition: 'right',
//     //navigationTooltips: ['First page', 'Second page', 'Third and last page']
//     onLeave: function (origin, destination, direction) {
//       timer.stop();
//       destLat = destination.item.dataset.mylat;
//       destLon = destination.item.dataset.mylon;

//       if (destLat != null) {
//         rotate = [destLon, destLat];
//         $(".points > .point").removeClass("active");

//         if (typeof rotateMe == 'function')
//           rotateMe(rotate);

//         $(".points > #point" + destination.item.dataset.pointid).addClass("active");
//       } else {
//         $(".point").removeClass("inactive");
//         $(".points .point").removeClass("active");
//       }
//     },
//   });
// }


// (function($){

//   $.fn.detachTemp = function() {
//       this.data('dt_placeholder',$('<span style="display: none;" />')
//           .insertAfter( this ));
//       return this.detach();
//   }

//   $.fn.reattach = function() {
//       if(this.data('dt_placeholder')){
//           this.insertBefore( this.data('dt_placeholder') );
//           this.data('dt_placeholder').remove();
//           this.removeData('dt_placeholder');
//       }
//       else if(window.console && console.error)
//       console.error("Unable to reattach this element because its placeholder is not available.");
//       return this;
//   }

// })(jQuery);


function multilangualForm() {
  $(".language-filter > li > a").on("click", function (e) {
    e.preventDefault();
    // console.log("filter by language");
    selectedLang = $(this).data("language");
    // console.log(selectedLang);
    $(".form-wrapper").removeClass("active");
    $(".mu-forms-wrapper")
      .find("[data-language=" + selectedLang + "]")
      .addClass("active");
  });
}

function jotFormToggler() {
  $(".jotform-toggler").on("click", function (e) {
    e.preventDefault();
    selectedForm = $(this).data("jotform");
    console.log(selectedForm);
    $(".jotform-toggler").removeClass("active");
    $(".form-wrapper").removeClass("active");
    
    $(this).addClass("active");
    $(".jotform-wrapper")
      .find("[data-jotform=" + selectedForm + "]")
      .addClass("active");
  });
}

function scrollDownButton() {
  var scrollSpeed = 500;

  $(document).on("click", ".scroll-down", function (e) {
    e.preventDefault();
    var currIndex = $(this)
      .closest(".flexible-content")
      .index();
    console.log('currIndex')
    var nextIndex = currIndex == 1 ? 3 : currIndex + 1;
    var nextSection = $(".flexible-content:nth-child(" + nextIndex + ")");
    if (nextSection.length === 0) return;
    $("html, body").animate(
      {
        scrollTop: nextSection.offset().top
      },
      scrollSpeed
    );
  });
}

function scrollToSection() {
  $(document).on("click", '.anchor[href^="#"]', function (event) {
    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top - 120
      },
      500
    );
  });
}

function hideLogoOnMobile() {
  if ($(window).width() <= 1100) {
    $(window).on("load scroll", function () {
      var scrolled = $(this).scrollTop();
      // console.log(scrolled);
      if (scrolled > 150) {
        $(".logo").fadeOut("fast");
      } else {
        $(".logo").fadeIn("fast");
      }
    });
  }
}

function parallax() {
  $(window).on("load scroll", function () {
    var scrolled = $(this).scrollTop();
    $("#heroVideo").css(
      "transform",
      "translate3d(0, " + -(scrolled * 0.4) + "px, 0)"
    ); // parallax
    $(".hero-bg").css(
      "transform",
      "translate3d(0, " + -(scrolled * 0.4) + "px, 0)"
    ); // parallax
    $(".ingress-container").css(
      "transform",
      "translate3d(0, " + -(scrolled * 0.4) + "px, 0)"
    ); // parallax (25% scroll rate)
    //$('.logo-text').css('opacity', (scrolled * 0.25) + '%;');
    // console.log(((100 - (scrolled * 0.1))) + '%;');
  });
}

function videoPlayer() {
  $(".video-container").each(function () {
    var video = $(this).find("video");
    var plainVideo = video.get(0); /*DOM video object, unwrapped from jQuery*/
    var playBtn = $(this).find("button");

    playBtn.click(function () {
      video.get(0).addEventListener("ended", myHandler, false);
      plainVideo.play();
      playBtn.fadeOut();
      video.attr("controls", true);

      function myHandler(e) {
        playBtn.fadeIn();
        video.removeAttr("controls");
      }
    });
  });
}

function employeeBio() {
  $(document).on("click", ".show-bio", function (e) {
    e.preventDefault();
    $(this)
      .closest(".employee-box")
      .toggleClass("active");
  });
}

function showMoreContent() {
  $(document).on("click", ".show-more", function (e) {
    e.preventDefault();
    var $this = $(this);
    var target = $this.data("target");
    var $hiddenContent;
    var moreText = $this.data("more-text");
    var lessText = $this.data("less-text");

    // class and text toggle
    $this.toggleClass("icon-plus icon-close");
    var text = $this.text();
    $this.text(text == moreText ? lessText : moreText);

    // hidden/more content
    if (target) $hiddenContent = $("#" + target);
    else
      $hiddenContent = $this
        .closest(".more-content-wrapper")
        .find(".more-content");

    $hiddenContent.slideToggle().toggleClass("active");
    //console.log(hiddenContent);
  });
}

function showMoreTable() {
  $(document).on("click", ".has-more-content", function (e) {
    e.preventDefault();
    $(this).toggleClass("expanded");
    var hiddenContent = $(this)
      .parent()
      .find(".more-content-table");
    hiddenContent.slideToggle();
    hiddenContent.toggleClass("active");
    // console.log(hiddenContent);
  });
}

function animateNumbers_old() {
  var delay = 0;
  document.addEventListener("aos:in:scrollMarker", function (detail) {
    $(".count").each(function () {
      delay = delay + 200;
      $(this)
        .prop("Counter", 0)
        .delay(delay)
        .animate(
          {
            Counter: $(this).text()
          },
          {
            duration: 2000,
            easing: "swing",
            step: function (now) {
              $(this).text(Math.ceil(now));
              var svg = $(this)
                .closest(".honeycomb")
                .find(".honeycomb-path");
              svg.delay(delay).addClass("honeycomb-animated");
            }
          }
        );
    });
  });
}

function animateNumbers() {
  var formatNumber = function (number) {
    if (number.indexOf(".") >= 0) {
      return $("html").attr("lang") == "no" ? number.replace(".", ",") : number;
    } else if (number.length > 3) {
      var replacementCharacter = $("html").attr("lang") == "no" ? " " : ",";
      return number.replace(/.{3}$/, replacementCharacter + "$&");
    } else {
      return number;
    }
  };

  var delay = 0;
  document.addEventListener("aos:in:scrollMarker", function (detail) {
    $(".count").each(function () {
      delay = delay + 200;
      var numberToCount = $(this);
      formattedNumber = $(this)
        .text()
        .replace(",", ".");
      numberSuffix = formattedNumber
        .replace(/\d+/g, "")
        .replace(",", "")
        .replace(".", "");
      var numberParts = formattedNumber.split(".");
      var numberDecimals = numberParts.length === 2 ? numberParts[1].length : 1;

      
      $(this)
        .prop("Counter", 0)
        .delay(delay)
        .animate(
          {
            Counter: formattedNumber
          },
          {
            duration: 2000,
            easing: "swing",
            step: function (now) {
              var s = now.toString();
              s = s.substr(
                0,
                s.indexOf(".") === -1
                  ? s.length
                  : s.indexOf(".") + (1 + numberDecimals)
              );
            
              if (!$(this).hasClass("disable-formatting")) {
                s = formatNumber(s);
              }

              numberToCount.text(s + numberSuffix);
              var svg = $(this)
                .closest(".honeycomb")
                .find(".honeycomb-path");
              svg.delay(delay).addClass("honeycomb-animated");
            }
          }
        );
    });
  });
}

function matchHeight() {
    let goalHeight,
        target;

    if (document.querySelector('.match-height-goal')) {
        goalHeight = document.querySelector('.match-height-goal').offsetHeight;
    } else {
        return;
    }

    if (document.querySelector('.match-height-target')) {
        target = document.querySelector('.match-height-target');
    } else {
        return;
    }

    target.style.height = goalHeight + 'px';
}

// Some old function for resizing images, check if needed
function resize() {
  var imageResizeTimeout = false;
  function resizeImages() {
    $(".image-fill-wrapper:not(.do-not-resize)").each(function () {
      var childImg = $(this).find("img");
      childImg.css("display", "block");
      if ($(window).width() <= 400) {
        childImg.css("width", "auto");
        childImg.css("height", "auto");
      } else if (childImg.width() < $(this).width()) {
        childImg.css("width", "100%");
        childImg.css("height", "auto");
      } else {
        childImg.css("height", "100%");
        childImg.css("width", "auto");
      }
    });
  }
  $(window).resize(function () {
    clearTimeout(imageResizeTimeout);
    imageResizeTimeout = setTimeout(resizeImages, 200);
  });
  //resizeImages();
  $(window).trigger("resize");
  window.setTimeout(function () {
    $(window).trigger("resize");
  }, 1200);
}

function getSelectedYear() {
  $(".download-center  select[name=posts-by-year]").change(function () {
    var yearSelected = $(this).val();
    fetchDownloadsAjax(yearSelected);
  });

  $('.download-center .year-filter > li > a').on('click', function (e) {
    e.preventDefault();
    console.log("filter by year");


    var year_text = $(this).text();
    $(".download-center .year-filter>li>a").removeClass("active");
    $(".download-center #year-toggle").text(year_text);

    if (year_text != 'All') {
      $(".download-center .year-filter").find('[data-year=' + year_text + ']').addClass("active");
    } else {
      $(".download-center .all-years").addClass("active");
    }

    fetchDownloadsAjax(year_text);
  });

}



function getSelectedYearPolicies(yearDefault) {

  fetchPoliciesAjax(yearDefault);

  // THIS GOT COMMENTED OUT - CLIENT REQUEST FOR DISABLING FILTERS.
  // REMOVE COMMENT TO ENABLE AND SET $YEARS IN DOWNLOAD-CENTER-POLICIES.PHP TO ENABLE
    $(".download-center-policies select[name=posts-by-year]").change(function() {
      var yearSelected = $(this).val();
      fetchPoliciesAjax(yearSelected);
    });

    $('.download-center-policies .year-filter > li > a').on('click', function (e) {
      e.preventDefault();
      console.log("filter by year");


      var year_text = $(this).text();
      $(".download-center-policies .year-filter>li>a").removeClass("active");
      $(".download-center-policies #year-toggle").text(year_text);

      if (year_text != 'All') {
          $(".download-center-policies .year-filter").find('[data-year=' + year_text + ']').addClass("active");
      } else {
          $(".download-center-policies .all-years").addClass("active");
      }

      fetchPoliciesAjax(year_text);
  });

}


function ninjaFormBreadcrumbs() {
  $(".nf-breadcrumb").text("1asdsada");
}

function dropdown_location() {
  var $location_filter = $("#location-filter");
  $(document).on("click", ".filter-toggle", function (e) {
    var $this = $(this);
    $this.closest(".filter-container").toggleClass("active");
    $location_filter.slideToggle("fast");
    $this.toggleClass("icon-dropdown-close");
  });

  $(document).on(
    "click",
    ".filter-container.active .location-filter li a",
    function (e) {
      var $this = $(this);

      $this
        .closest(".filter-container")
        .toggleClass("active")
        .find(".filter-toggle")
        .toggleClass("icon-dropdown-close");

      $location_filter.slideToggle("fast");

      var target_id = $this.attr("href");
      target_id = target_id.substring(1);
      var $target = $(".content").find('[data-anchor="' + target_id + '"]');
      // console.log($target);
      $("html, body").animate(
        {
          scrollTop: $target.offset().top
        },
        500
      );
    }
  );
}

function welcome_message_in_console() {
  var txt =
    "   _____           _             _____       _            \n" +
    "  / ____|         | |           / ____|     | |           \n" +
    " | (___   ___ __ _| |_ ___  ___| (___   ___ | | __ _ _ __ \n" +
    "  \\___ \\ / __/ _` | __/ _ \\/ __|\\___ \\ / _ \\| |/ _` | '__|\n" +
    "  ____) | (_| (_| | ||  __/ (__ ____) | (_) | | (_| | |   \n" +
    " |_____/ \\___\\__,_|\\__\\___|\\___|_____/ \\___/|_|\\__,_|_|   \n" +
    "                                                          \n" +
    "                                                          ";
  console.log("%c " + txt, "color: #ff9600");
}

